import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFullAdmin, hasArea } from '../services/auth';

// Wrap admin routes a Limited Admin must not reach unless granted.
// - With an `area` prop: allow full admins, or a limited admin who holds that grant.
// - Without `area`: full admins only.
// The backend still enforces access; this keeps the UI from showing a blocked page.
export default function FullAdminRoute({ area, children }) {
  const ok = area ? hasArea(area) : isFullAdmin();
  if (!ok) return <Navigate to="/admin/dashboard" replace />;
  return children;
}
